// Written by Claude Code on 2026-02-21
// User prompt: yes update firebase.js

import { initializeApp } from "firebase/app";
import { getAuth, setPersistence, browserSessionPersistence } from "firebase/auth";

const env = (key) => window.ENV?.[key] || process.env[key];

const firebaseConfig = {
  apiKey: env('REACT_APP_FIREBASE_API_KEY'),
  authDomain: env('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: env('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: env('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: env('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: env('REACT_APP_FIREBASE_APP_ID'),
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// Each browser tab gets its own independent auth session. Logging in or out
// in one tab has no effect on other tabs — required for multi-account workflows.
setPersistence(auth, browserSessionPersistence).catch(() => {});
